var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { id: "modal-informational", "hide-header-close": "" },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function () {
            return [_vm._v("Information")]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "b-button",
                {
                  staticClass: "btn btn-primary",
                  on: {
                    click: function ($event) {
                      return _vm.$bvModal.hide("modal-informational")
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-12 col-md-12" }, [
          _c(
            "div",
            {
              staticClass: "pull-left",
              staticStyle: {
                width: "70px",
                "min-width": "70px",
                "max-width": "70px",
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-info-circle fa-4x",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          ),
          _c("div", [_c("p", [_vm._v(_vm._s(_vm.message))])]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }